import store from '@/state/store';
import { get } from '@/api/project';
import { fetch } from '@/api/model';
import { handleError } from '@/actions/common';
import projectSlice from '@/state/project.slice';
// import commonSlice from '@/state/common.slice';
import { RequestStatus } from '@/contracts';
import processModels from './process-models';
import processTree from './process-tree';
import { ApiError } from '@bimdata/client';
import t from '@/utils/translate';

import { loadStats } from './classification.loader';

export default async (id: string, accessToken?: string): Promise<void> => {
  const { projects } = store.getState();
  if (
    (projects.current && projects.current.code == id)
    || projects.openingStatus === RequestStatus.BUSY
  ) return;

  store.dispatch(projectSlice.actions.open());
  try {
    const p = await get(id, accessToken);

    const models = await fetch(id, true, accessToken);

    const tree = await loadStats(id, accessToken);

    store.dispatch(projectSlice.actions.opened({
      key: `${p.code}`,
      code: p.code,
      name: p.name,
      access: p.access,
      logo: p.logo,
      revit3DView: p.revit3DView || null,
      importRevitEdges: p.importRevitEdges || false,
      additionalSections: p.additionalSections,
      ...processModels(models),
      ...processTree(tree),
      invitations: null,
      participants: null,
    }));
    // store.dispatch(commonSlice.actions.setTitle(p.name));
  } catch (error) {
    if (error instanceof Error) {
      if (error instanceof ApiError && (error.code === 404 || error.code === 403)) {
        error.message = t('project.error.notFoundOrAccessDenied');
      }
      store.dispatch(projectSlice.actions.openFailed(error));
      handleError(error, accessToken);
    } else {
      throw error;
    }
  }
};
